import { localStorage } from '@apparel/core/storage';

const storage = localStorage;
const KEY = '__token__';
const USER = '__user__';
const CUSTOMER = '__customer__';

/**
 * Set JWT into our defined storage
 * @param token
 */
export function setToken(token: string): void {
    storage.setItem(KEY, token, { encode: false });
}

/**
 * JWT getter
 * @returns {string}
 */
export function getToken(): string {
    return storage.getItem(KEY, { encode: false });
}

/**
 * JWT destroyer
 */
export function clearToken(): void {
    storage.removeItem(KEY, { encode: false });
}

/**
 * User getter
 * @returns {any}
 */
export function getUser(): any {
    return storage.hasItem(USER) ? storage.getItem(USER) : null;
}

/**
 * User setter
 * @param user
 */
export function setUser(user: { [key: string]: any }): void {
    storage.setItem(USER, user);
}

/**
 * Clear User
 */
export function clearUser(): void {
    storage.removeItem(USER);
}

/**
 * Customer getter
 * @returns {any}
 */
export function getCustomer(): null {
    return storage.hasItem(CUSTOMER) ? storage.getItem(CUSTOMER) : null;
}

/**
 * Customer setter
 * @param user
 */
export function setCustomer(user: { [key: string]: any }): void {
    storage.setItem(CUSTOMER, user);
}

/**
 * Clear Customer
 */
export function clearCustomer(): void {
    storage.removeItem(CUSTOMER);
}
